import { cn } from "@lib/cn";
import { IconFile, IconLoader2, IconX } from "@tabler/icons-react";
import { useAiImageStoreShallow } from "../store";

type UploadFilePreviewProps = {
  fileName: string;
  extension: string;
  loading: boolean;
  onRemove?: () => void;
  className?: string;
};

export const UploadFilePreviews = () => {
  const { referenceImages, removeReferenceImage } = useAiImageStoreShallow(
    (s) => ({
      referenceImages: s.referenceImages,
      removeReferenceImage: s.removeReferenceImage,
    }),
  );

  if (referenceImages.length === 0) {
    return null;
  }
  return (
    <div className="tw-w-full tw-min-w-0 tw-overflow-x-auto tw-max-w-[534px] no-scrollbar">
      <div className="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-flex-nowrap tw-w-max">
        {referenceImages.map((image) => (
          <UploadFilePreview
            key={image.id}
            fileName={image.name}
            extension={image.extension}
            loading={image.loading}
            onRemove={() => removeReferenceImage(image.id)}
          />
        ))}
      </div>
    </div>
  );
};
const UploadFilePreview = ({
  fileName,
  extension,
  loading,
  onRemove,
  className,
}: UploadFilePreviewProps) => {
  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-rounded-lg tw-w-52 tw-bg-[#FDFCFD] tw-outline tw-outline-1 tw-outline-blue-100 tw-flex-shrink-0",
        className,
      )}
    >
      {loading ? (
        <IconLoader2 className="tw-size-[14px] tw-text-blue-500 tw-flex-shrink-0 tw-animate-spin" />
      ) : (
        <IconFile className="tw-size-[14px] tw-text-blue-500 tw-flex-shrink-0" />
      )}
      <span className="tw-flex tw-items-center tw-font-sans tw-text-sm tw-font-normal tw-text-blue tw-min-w-0 tw-flex-1">
        <span className="tw-truncate">{fileName}</span>
        {extension && (
          <span className="tw-flex-shrink-0 tw-text-blue">.{extension}</span>
        )}
      </span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="tw-flex-shrink-0 tw-ml-4 tw-flex tw-items-center tw-justify-center tw-size-6 tw-rounded-lg tw-bg-blue-50 hover:tw-bg-blue-100 tw-transition-colors tw-cursor-pointer"
          aria-label="Remove file"
        >
          <IconX className="tw-size-[14px] tw-text-blue-800" />
        </button>
      )}
    </div>
  );
};
